import { render, staticRenderFns } from "./CsSynopsis.vue?vue&type=template&id=46330324&"
import script from "./CsSynopsis.vue?vue&type=script&lang=js&"
export * from "./CsSynopsis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports